export function initFaq() {
    faqToggle();
}

function faqToggle() {
    const faqItems = document.querySelectorAll('.accordion-item');

    faqItems.forEach(item => {
        const title = item.querySelector('.accordion-title');
        const content = item.querySelector('.accordion-content');

        title.addEventListener('click', (event) => {
            event.preventDefault();
            const isOpen = item.classList.contains('is-active');

            // Close all items
            faqItems.forEach(i => {
                i.classList.remove('is-active');
                $(i.querySelector('.accordion-content')).slideUp();
            });

            // Toggle the clicked item
            if (!isOpen) {
                item.classList.add('is-active');
                $(content).slideDown();
            }
        });
    });
}